import React from 'react';
import { Popover } from 'antd';
import './index.scss'
export default class WWPopover extends React.Component{
    constructor(props) {
        super(props);
    }

    render () {
        return (
            <Popover {...this.props}/>
        )
    }
}